import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M.235 4.865a4.63 4.63 0 0 1 4.63-4.63h14.27a4.63 4.63 0 0 1 4.63 4.63v14.27a4.63 4.63 0 0 1-4.63 4.63H4.865a4.63 4.63 0 0 1-4.63-4.63zM12 7.205a4.796 4.796 0 1 0 0 9.59 4.796 4.796 0 0 0 0-9.59M5.815 12a6.185 6.185 0 1 1 12.37 0 6.185 6.185 0 0 1-12.37 0m14.028-9.412a1.569 1.569 0 1 0 0 3.137 1.569 1.569 0 0 0 0-3.137",
      "clip-rule": "evenodd"
    }, null, -1)
  ]))]))
}
export default { render: render }